export enum AtpStatusType {
  DEACTIVATED = 'Deactivated',
  ACTIVE = 'Active',
  EXPIRED = 'Expired',
  DOWNGRADED = 'Downgraded',
}

export default interface AccountDto {
  id: string;
  deals?: string[];
  name: string;
  logoUrl: string;
  welcome: AccountWelcomeDto;
  videoTranscriptData: string;
  twoFaInterval: number;
  isChannelEngagement?: boolean;
  access?: SelfServiceAccountAccessDto;
  accountContactEmail: string;
  isAnonymizable?: boolean;
  engagements: string[];
  payByUserDeals?: string[];
  hasPayByUserDeal: boolean;
  atpStatusTypeId: AtpStatusType;
}

export interface AccountWelcomeDto {
  title: string;
  content: string;
  video: AccountWelcomeVideoDto;
  videoTranscriptData: string;
}

export interface AccountWelcomeVideoDto {
  videoUrl: string;
  transcriptUrl: string;
  show: boolean;
}

export interface AccountUserDto {
  personId: number;

  email: string;

  name: string;

  accountRole: AdminUserRoleDto;

  dealRoles: AdminUserRoleDto[];
}

export interface AdminUserRoleDto {
  roleId: string;
  roleName: string;
  invitedByPersonId?: number;
  invitedByPersonName?: string;
  created?: Date;
  dealId?: string;
}

export interface SelfServiceAccountAccessDto {
  accountNumber: string;
  orderAccess: boolean;
  orderHistoryAccess: boolean;
}
